import { mountWidget } from './Widget';

function resolveApiBase(script: HTMLScriptElement): string {
  const explicit = script.dataset.apiBase?.trim();
  if (explicit) return explicit;
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  return window.location.origin;
}

function resolveEmbeddingScript(): HTMLScriptElement | null {
  const byId = document.getElementById("beauty-advisor-widget");
  if (byId instanceof HTMLScriptElement) return byId;

  const tagged = document.querySelector<HTMLScriptElement>(
    'script[data-clinic-slug][src*="embed.js"], script[data-clinic-slug][src*="widget.js"]',
  );
  if (tagged) return tagged;

  if (document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript;
  }

  return null;
}

function bootstrap(): void {
  const script = resolveEmbeddingScript();

  if (!script) {
    console.error('[beauty-widget] Could not find embedding script tag.');
    return;
  }

  const clinicSlug = script.dataset.clinicSlug?.trim() ?? '';
  const apiBase = resolveApiBase(script);

  if (!clinicSlug) {
    console.error('[beauty-widget] Missing data-clinic-slug on script tag.');
    return;
  }

  if (document.querySelector('.beauty-widget-host')) {
    return;
  }

  const host = document.createElement('div');
  host.className = 'beauty-widget-host';
  document.body.appendChild(host);

  mountWidget(host, clinicSlug, apiBase);
}

function scheduleBootstrap(): void {
  bootstrap();
  // TanStack SSR hydration can remove the host node; retry after paint.
  window.setTimeout(bootstrap, 300);
  window.setTimeout(bootstrap, 1500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleBootstrap);
} else {
  scheduleBootstrap();
}
